function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  rx: 12,
  fill: "#F0E8FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_diiiidsdds)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.2275 29.9285C59.8544 30.631 63.4 34.626 63.4 39.4491C63.4 44.7677 59.0884 49.0793 53.7698 49.0793H26.6302C21.3116 49.0793 17 44.7677 17 39.4491C17 34.3195 21.0106 30.1266 26.0671 29.8351C27.4735 23.0773 33.4626 18 40.6377 18C47.8458 18 53.8571 23.1242 55.2275 29.9285Z",
  fill: "#6D00FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.2275 29.9285C59.8544 30.631 63.4 34.626 63.4 39.4491C63.4 44.7677 59.0884 49.0793 53.7698 49.0793H26.6302C21.3116 49.0793 17 44.7677 17 39.4491C17 34.3195 21.0106 30.1266 26.0671 29.8351C27.4735 23.0773 33.4626 18 40.6377 18C47.8458 18 53.8571 23.1242 55.2275 29.9285Z",
  fill: "url(#paint0_linearsdafa)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.2275 29.9285C59.8544 30.631 63.4 34.626 63.4 39.4491C63.4 44.7677 59.0884 49.0793 53.7698 49.0793H26.6302C21.3116 49.0793 17 44.7677 17 39.4491C17 34.3195 21.0106 30.1266 26.0671 29.8351C27.4735 23.0773 33.4626 18 40.6377 18C47.8458 18 53.8571 23.1242 55.2275 29.9285Z",
  fill: "url(#paint1_linearasfsafasd)",
  fillOpacity: 0.7
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_disdsds)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.893 39.343H33.8114C35.3544 39.343 36.1583 40.4468 36.1583 41.8085V51.843H31.9705C31.5963 51.843 31.3946 52.2821 31.6384 52.5659L38.294 60.3153C38.5586 60.6234 39.0638 60.4363 39.0638 60.0301V55.1218H39.0639V41.8085C39.0639 38.8129 37.206 36.3845 33.8114 36.3845H31.893C31.4095 36.3845 31.0176 36.7765 31.0176 37.26V38.4676C31.0176 38.9511 31.4095 39.343 31.893 39.343Z",
  fill: "#FCF0FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.2573 57.5019H48.339C46.796 57.5019 45.9921 56.3981 45.9921 55.0365V45.0022H50.1798C50.554 45.0022 50.7556 44.5631 50.5118 44.2792L43.8563 36.5299C43.5916 36.2217 43.0864 36.4089 43.0864 36.8151V45.0022H43.0865V55.0365C43.0865 58.0321 44.9444 60.4604 48.339 60.4604H50.2573C50.7409 60.4604 51.1328 60.0685 51.1328 59.585V58.3774C51.1328 57.8939 50.7409 57.5019 50.2573 57.5019Z",
  fill: "#FCF0FF"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_diiiidsdds",
  x: 4.28477,
  y: 5.16172,
  width: 71.8305,
  height: 65.1916,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.55885
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.35762
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.844787 0 0 0 0 0.639132 0 0 0 0 0.970833 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -12.8383
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 28.6093
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.5835 0 0 0 0 0.575 0 0 0 0 1 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -9.53643
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.13245
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow",
  result: "effect3_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.35762
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.45033
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_innerShadow",
  result: "effect4_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.06667
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.634667 0 0 0 0 0.462745 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_innerShadow",
  result: "effect5_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_disdsds",
  x: 28.8842,
  y: 35.2028,
  width: 24.3814,
  height: 29.5326,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.13333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.06667
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.456 0 0 0 0 0.2 0 0 0 0 1 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1.17367
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.782446
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.696 0 0 0 0 0.2 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linearsdafa",
  x1: 41.3075,
  y1: 5.99661,
  x2: 41.3075,
  y2: 41.6255,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00520833,
  stopColor: "white",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0851933,
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.336988,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.660917,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linearasfsafasd",
  x1: 41.2706,
  y1: 17.2511,
  x2: 41.2706,
  y2: 48.5896,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#994EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgIconMore2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore2);
export default __webpack_public_path__ + "static/media/icon_more_2.8d99edd2.svg";
export { ForwardRef as ReactComponent };